import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as Feather from 'feather-icons';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TransferDataService } from 'src/app/services/transfer-data/transfer-data.service';
import { empty } from 'src/app/utils/functions';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {
  logoutPending: boolean;
  user: any;
  username: string;
  userFetched: boolean;
  path = '';
  constructor(
    private router: Router,
    private authService: AuthService,
    private transferService: TransferDataService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.path = event.url;
      }
    });

  }
  ngAfterViewInit(): void {
    Feather.replace();
  }

  ngOnInit() {
    this.getUser();
  }


  logout() {
    if (this.logoutPending) { return; }
    this.logoutPending = true;
    this.authService.logout().subscribe(res => {
      this.authService.logoutUser();
      this.logoutPending = false;
    }, err => {
      this.authService.logoutUser();
      this.logoutPending = false;
    });
  }

  getUser() {
    this.transferService.getAuthUser().subscribe((user: any) => {
      if (empty(user)) { return; }
      this.user = user;
      this.username = this.user.username;
    });
  }
}
